module.exports = __webpack_public_path__ + "img/no-img.173ac720.png";